import React from 'react'

import { Container } from '@scentregroup/ui'
import { AngleBackground, AngleType } from '../angle-background'
import style from './index.scss'

export const MarketplaceAngleContainer: React.FC = ({ children }) => (
  <div className={style.MarketplaceAngleContainer}>
    <AngleBackground
      className={style.background}
      angleType={AngleType.topLeft}
    />
    <Container type="large" className={style.container}>
      {children}
    </Container>
  </div>
)
